<template>
    <div v-if="items.length" class="pending-send-stack">
        <div v-for="it in items" :key="it.id" class="pending-send-bar" :class="{ 'psb-sending': it.status === 'sending' }">
            <div class="psb-progress" :style="{ width: progressPct(it) + '%' }"></div>
            <div class="psb-content">
                <i class="material-icons md-18 psb-icon">{{ it.status === 'sending' ? 'send' : 'schedule_send' }}</i>
                <span class="psb-text">
                    <template v-if="it.status === 'sending'">
                        Wysyłanie{{ it.ticketNumber ? ' (' + it.ticketNumber + ')' : '' }}…
                    </template>
                    <template v-else>
                        Wiadomość{{ it.ticketNumber ? ' (' + it.ticketNumber + ')' : '' }} zostanie wysłana za {{ seconds(it) }} s
                    </template>
                </span>
                <button v-if="it.status === 'pending'" type="button" class="psb-cancel" @click="cancel(it.id)">
                    <i class="material-icons md-14">undo</i> Cofnij wysyłkę
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import PendingSendManager from '../../PendingSendManager.js';

export default {
    name: 'PendingSendBar',
    computed: {
        items() {
            return PendingSendManager.state.items;
        }
    },
    methods: {
        seconds(it) {
            return Math.max(0, Math.ceil(it.remainingMs / 1000));
        },
        progressPct(it) {
            if (it.status === 'sending') return 100;
            const elapsed = it.delayMs - it.remainingMs;
            return Math.min(100, Math.max(0, (elapsed / it.delayMs) * 100));
        },
        cancel(id) {
            PendingSendManager.cancel(id);
        }
    }
};
</script>

<style scoped>
.pending-send-stack {
    position: fixed;
    left: 16px;
    bottom: 16px;
    z-index: 12000;
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-width: 420px;
}
.pending-send-bar {
    position: relative;
    overflow: hidden;
    background: #1f2937;
    color: #fff;
    border-radius: 8px;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.25);
    min-width: 320px;
}
.psb-progress {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    background: rgba(59, 130, 246, 0.35);
    transition: width 0.1s linear;
}
.pending-send-bar.psb-sending .psb-progress {
    background: rgba(34, 197, 94, 0.35);
}
.psb-content {
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
}
.psb-icon { flex-shrink: 0; }
.psb-text { flex: 1; font-size: 13px; }
.psb-cancel {
    flex-shrink: 0;
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.4);
    color: #fff;
    border-radius: 6px;
    padding: 4px 10px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 4px;
}
.psb-cancel:hover {
    background: rgba(255, 255, 255, 0.12);
}
</style>
